import { IGetItemsResult } from '../types/IGetItemsResult';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDisassociateOAuthCredentialParams extends IGetItemsResult {
  resourceId: string;     // ID of the workbook or datasource to remove the keychain from.
  resourceType: string;   // "Workbook" or "Datasource"
}

export class DisassociateOAuthCredentialRequest extends Request<IDisassociateOAuthCredentialParams, IEmptyResult> {
  constructor(params: IDisassociateOAuthCredentialParams) {
    super('disassociateOAuthCredential', params);
  }
}
